import api from "api/api";

export const getRecruitmentMethodes = async () =>
  await api.get("/settings/recruitment_method");

export const deleteRecruitmentMethodById = async (id) =>
  await api.delete(`/settings/recruitment_method/${id}`);

export const getRecruitmentMethodById = async (id) =>
  await api.get(`/settings/recruitment_method/${id}`);

export const createRecruitmentMethod = async (data) =>
  await api.post("/settings/recruitment_method", data);

export const updateRecruitmentMethodById = async (id, data) =>
  await api.put(`/settings/recruitment_method/${id}`, data);
